/**
 * The access token, held in memory only.
 *
 * Never written to localStorage or sessionStorage. The refresh token is an
 * httpOnly cookie precisely so JavaScript cannot read it; leaving a bearer token
 * in storage next to it would hand XSS a working credential anyway and reduce
 * the cookie to decoration.
 *
 * The cost is that a hard reload starts with no token. That is recovered by a
 * refresh call at startup (see `bootstrapSession`), not by persisting the token.
 */

let accessToken = '';

export function getAccessToken(): string {
  return accessToken;
}

export function setAccessToken(token: string): void {
  accessToken = token ?? '';
}

export function clearAccessToken(): void {
  accessToken = '';
}
